module.exports = __webpack_public_path__ + "img/fish_icon.d36428fb.png";